<template>
  <div
    class="CardGroup row"
    :id="id"
    :style="options.style">
    <div
      v-if="options.hasMessage"
      class="CardGroupMessage"
      :style="options.messageStyles">
      <card-label v-if="options.label" :label="options.label"/>
      <card-header v-if="options.header" :header="options.header"/>
      <card-sub-header v-if="options.subHeader" :subHeader="options.subHeader"/>
    </div>
    <card v-for="card in cards"
      :button="card.button"
      :tight="tight"
      :size="card.size"
      :padBottom="padBottom"
      :height="card.height"
      :width="card.width"
      :contentStyle="card.contentStyle"
      :backgroundPosition="card.backgroundPosition"
      :backgroundRepeat="card.backgroundRepeat"
      :backgroundImage="card.backgroundImage"
      :backgroundColor="card.backgroundColor"
      :backgroundSize="card.backgroundSize"
      :label="card.label"
      :header="card.header"
      :subHeader="card.subHeader">
      <template v-if="customContent">
        <div v-html="customContent" />
      </template>
      <template v-else>
        <card-label :label="card.label"/>
        <card-header :header="card.header"/>
        <card-sub-header :subHeader="card.subHeader"/>
        <card-button :button="card.button"/>
        <card-image :image="card.image"/>
        <div v-if="card.customSlotContent" :style="calculatedStyle(card)" v-html="$t(card.customSlotContent.body)" />
      </template>
    </card>
  </div>
</template>

<script>
import Card from '../Card'
import CardLabel from '../CardLabel'
import CardImage from '../CardImage'
import CardHeader from '../CardHeader'
import CardButton from '../CardButton'
import CardSubHeader from '../CardSubHeader'

export default {
  name: 'card-group',
  props: {
    id: {
      type: String
    },
    cards: {
      type: Array,
      required: true
    },
    padBottom: {
      type: Boolean,
      default: true
    },
    tight: {
      type: Boolean,
      default: false
    },
    customContent: {
      type: String
    },
    options: {
      type: Object
    },
    mobileHeight: {
      type: String
    }
  },
  methods: {
    calculatedStyle(card) {
      console.log(card, this.$mq);
      if (card.customSlotContent.style && card.customSlotContent.style.sm && this.$mq === 'sm') {
        return { ...card.customSlotContent.style, ...card.customSlotContent.style.sm }
      } else if (card.customSlotContent.style && card.customSlotContent.style.lg && this.$mq === 'lg') {
        return { ...card.customSlotContent.style, ...card.customSlotContent.style.lg }
      } else {
        return card.customSlotContent.style
      }
    }
  },
  components: {
    Card,
    CardLabel,
    CardImage,
    CardHeader,
    CardButton,
    CardSubHeader
  }
}
</script>

<style lang="scss">
.CardGroup {
  position: relative;

  .CardGroupMessage {
    padding: 0 2rem;
    position: absolute;
    top: 50%;
    width: 100%;
    z-index: 999;
    transform: translateY(-50%);
  }

  .CardElement:not(.tight) {
    .CardWrap {
      margin-left: 0.25rem;
      margin-right: 0.25rem;
    }

    &:first-child {
      .CardWrap {
        margin-left: 0;
      }
    }

    &:last-child {
      .CardWrap {
        margin-right: 0;
      }
    }
  }
}
</style>